module.exports = __webpack_public_path__ + "img/ebicicleta.574e9ff2.svg";